import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { File } from '../../files/file.model';

export const SIGNATURE_SCHEMA = Object.freeze({
  PRINTED_NAME: '',
  DATE: null, // i2g-timezoneless-date (yyyy-mm-dd)
  FILE: null, // File
  SIGNED_PDF_LEGACY_SUPPORT: null, // File
});
const RECORD = generateSchema(SIGNATURE_SCHEMA);
const KEYS: any = generateKeys(SIGNATURE_SCHEMA);

export class Signature extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.FILE,
        value: props.get(KEYS.FILE) ? new File(this.file) : null,
      },
      {
        key: KEYS.SIGNED_PDF_LEGACY_SUPPORT,
        value: props.get(KEYS.SIGNED_PDF_LEGACY_SUPPORT)
          ? new File(this.signedPdfLegacySupport)
          : null,
      },
    ]);

    return selfModel as Signature;
  }

  get printedName(): string {
    return this.get(KEYS.PRINTED_NAME);
  }

  get date(): string {
    return this.get(KEYS.DATE);
  }

  get file(): File {
    return this.get(KEYS.FILE);
  }

  get signedPdfLegacySupport(): File {
    return this.get(KEYS.SIGNED_PDF_LEGACY_SUPPORT);
  }
}
